export default __webpack_public_path__ + "890015f86d4803416e33e9074b17431a.svg";